import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { blogGet } from '../api';

export default function BlogPost() {
  const { slug }           = useParams();
  const [art,setArt]       = useState(null);
  const [related,setRel]   = useState([]);
  const [loading,setLoad]  = useState(true);
  const [error,setErr]     = useState('');

  useEffect(()=>{
    blogGet(slug).then(r=>{ setArt(r.data.article); setRel(r.data.related||[]); }).catch(()=>setErr('Article not found')).finally(()=>setLoad(false));
  },[slug]);

  if(loading) return <div className="text-center py-20 text-gray-400">Loading article...</div>;
  if(error)   return <div className="text-center py-20"><p className="text-red-500 mb-4">{error}</p><Link to="/blog" className="text-blue-600 hover:underline">← Back to articles</Link></div>;
  if(!art)    return null;

  return(
    <div className="max-w-3xl mx-auto px-6 py-8">
      <Link to="/blog" className="flex items-center gap-2 text-blue-600 text-sm mb-6 hover:text-blue-800"><ArrowLeft size={16}/>Back to News & Articles</Link>
      <div className="bg-gradient-to-br from-blue-900 to-blue-700 rounded-2xl h-48 flex items-center justify-center text-7xl mb-6">{art.emoji||'📰'}</div>
      <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full font-medium">{art.category}</span>
      <h1 className="text-3xl font-bold text-blue-950 mt-3 mb-2">{art.title}</h1>
      <div className="flex items-center gap-3 text-sm text-gray-400 mb-6 pb-6 border-b border-gray-100 flex-wrap">
        <span>By {art.author}</span><span>·</span>
        <span>{art.published_at?new Date(art.published_at).toLocaleDateString():''}</span>
        <div className="flex gap-1 ml-auto flex-wrap">
          {art.tags?.split(',').map(t=>t.trim()).filter(Boolean).map((t,i)=>(
            <span key={i} className="text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded-full">{t}</span>
          ))}
        </div>
      </div>
      <div className="space-y-2">
        {art.content.split('\n').map((line,i)=>(
          <p key={i} className={"text-gray-700 leading-relaxed "+(line.length===0?'h-3 block':'')}>{line||<span>&nbsp;</span>}</p>
        ))}
      </div>
      {related.length>0&&(
        <div className="mt-10 pt-8 border-t border-gray-100">
          <h3 className="font-bold text-gray-800 mb-4">Related Articles</h3>
          <div className="grid grid-cols-2 gap-4">
            {related.map(a=>(
              <Link key={a.id} to={`/blog/${a.slug}`} className="bg-gray-50 rounded-xl p-4 hover:bg-gray-100 transition">
                <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">{a.category}</span>
                <h4 className="font-semibold text-gray-800 text-sm mt-2 leading-snug">{a.title}</h4>
                <p className="text-xs text-gray-400 mt-1">{a.published_at?new Date(a.published_at).toLocaleDateString():''}</p>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
